// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"df32cc88","239":"7bbbf9fd","453":"73b47593","732":"6d76f447"}[chunkId] + ".chunk.js";
};